<template>
  <div class="header_white flex-align-between">
    <div class="header_left flex-align" @click="goHome()">
      <!-- <span style="margin-right:20px;">银川教育局</span> -->
      <!-- <img src="@/assets/img/footer/cnu_white.png" /> -->
      <!-- <img src="@/assets/img/footer/logo_white.png" /> -->
      <img class="header-logo" src="@/assets/img/footer/logo-help-white.png" alt="双优云桥" />
      <!-- <img src="@/assets/img/footer/logo-three-white.png" /> -->
      <!-- <span>智慧研修网</span> -->
    </div>
    <div class="header_right flex-align-around">
      <div class="menu_item" :class="[active == index ? 'active' : '']" v-for="(item, index) in menuList" :key="index"
        @click="goPage(item, index)" @mouseenter="showBox(item.navName)" @mouseleave="hiddenBox(item.navName)">
        {{ item.navName }}
        <div class="menu_item-son" v-if="newsBox && index === 1">
          <h3 @click.stop="goOtherPage(item.navName, '/news')">新闻首页</h3>
          <h3 @click.stop="goOtherPage(item.navName, '/news/headlines')">新闻头条</h3>
          <h3 @click.stop="goOtherPage(item.navName, '/news/topic')">专题新闻</h3>
          <h3 @click.stop="goOtherPage(item.navName, '/news/composite')">综合新闻</h3>
          <!-- <h3 @click.stop="goOtherPage(item.navName,'/news/school')">学校风采</h3>
            <h3 @click.stop="goOtherPage(item.navName,'/news/student')">学员风采</h3> -->
          <!-- <h3 @click.stop="goOtherPage('/news/course')">优秀课程</h3> -->
        </div>
        <div class="menu_item-son" v-if="hasBox && index === 2">
          <!-- <h3 @click.stop="goOtherPage(item.navName,'/yunqiao')">首都带首府</h3> -->
          <!-- <h3 @click.stop="goOtherPage(item.navName,'/yunqiao/logistics')">1+X后勤管理与职业教育系统</h3> -->
          <!-- <h3 @click.stop="goOtherPage(item.navName,'/yunqiao/detail_sddsf')">首都教育远程互助工程概况</h3> -->
          <div class="section flex-between">
            <div class="left-section">
              <span class="suabtitle">双优云桥</span>
              <h4 @click.stop="goOtherPage(item.navName, '/yunqiao/shoushi_project1')">名校联盟双师课堂</h4>
              <h4 @click.stop="goOtherPage(item.navName, '/yunqiao/shoushi_project2')">全学科互联网+项目 </h4>
              <h4 @click.stop="goOtherPage(item.navName, '/yunqiao/shoushi_project3')">课堂行为大数据分析项目</h4>
            </div>
            <div class="right-section">
              <span class="suabtitle">乐智学堂</span>
              <h4 @click.stop="goOtherPage(item.navName, '/yunqiao/lezhi_project1')">京银互动一带一路共读工程</h4>
              <h4 @click.stop="goOtherPage(item.navName, '/yunqiao/lezhi_project2')">STEAM课程</h4>
              <h4 @click.stop="goOtherPage(item.navName, '/yunqiao/lezhi_project3')">中小学生计算思维培养课程</h4>
              <h4 @click.stop="goOtherPage(item.navName, '/yunqiao/lezhi_project4')">教师信息化水平提升</h4>
              <h4 @click.stop="goOtherPage(item.navName, '/yunqiao/lezhi_project5')">中小学生综合素质评价</h4>
            </div>
          </div>
          <!-- <h3 @click.stop="goOtherPage(item.navName,'/yunqiao/wisdom')">首师智研</h3> -->
          <!-- <h3 @click.stop="goOtherPage(item.navName,'/yunqiao/innerMongolia')">内蒙古自治区三科统编教材中部四盟市教师专项培训</h3> -->
        </div>
      </div>
      <div class="login flex-align-center" @click="login()">
        <!-- <img src="@/assets/img/footer/login_white.png" /> -->
        <span>登录</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      hasBox: false,
      newsBox: false,
      menuList: [
        {
          navName:'首页',
          url:'/newHome'
        },
        {
          navName:'新闻资讯',
          url:'/news'
        },
        {
          navName:'云桥概况',
          url:'/yunqiao'
        },
        {
          navName:'特色项目',
          url:'/home'
        },
        {
          navName:'专题网站',
          url:'/website'
        }
      ],
      active: 0,
    };
  },
  methods: {
    login() {
      window.open('https://yc.cnuen.net/login');
    },
    goPage(item, index) {
      sessionStorage.setItem('active', index)
      if (item.navName !== '云桥概况' && item.navName !== '新闻资讯') {
        let url = item.url
        Common.goPage(url, this);
      }
    },
    goHome() {
      sessionStorage.setItem('active', 0)
      Common.goPage("/home", this);
    },
    // async getnav() {
    //   let resData = await Api.Header.getnavlist();
    //   console.log(resData.data);
    //   this.menuList = resData.data.filter(item => {
    //     return item.type == 1 && item.navName != "名师风采" && item.navName != '关于我们'
    //   })
    //   console.log(this.menuList)
    // },
    showBox(name) {
      if (name === '云桥概况') {
        this.hasBox = true;
      }
      if (name === '新闻资讯') {
        this.newsBox = true;
      }
    },
    hiddenBox(name) {
      if (name === '云桥概况') {
        this.hasBox = false;
      }
      if (name === '新闻资讯') {
        this.newsBox = false;
      }
    },
    goOtherPage(name, url) {
      // this.hasBox = false;
      if (name === '云桥概况') {
        sessionStorage.setItem('active', 2)
      } else if (name === '新闻资讯') {
        sessionStorage.setItem('active', 1)
      }

      if (url === '/yunqiao/innerMongolia' || url === '/yunqiao/wisdom' || url === '/yunqiao/logistics') {
        sessionStorage.setItem('wsActive', 1);
      }

      Common.goPage(url, this);
    }
  },
  mounted() {
    // this.getnav();
    if (sessionStorage.getItem('active')) {
      this.active = sessionStorage.getItem('active')
    }
  },
  activated() {
    if (sessionStorage.getItem('active')) {
      this.active = sessionStorage.getItem('active')
      console.log(this.active);
    }
  }
};
</script>

<style lang="less">
@import "./less/header_white.less";
</style>